/* NO DECORUM — interaction layer. Pairs with nd.css / nd-shop.css.
   Cursor bubble, colour-dot previews, newsletter without a reload,
   product page (options, gallery, zoom, bag, mobile bar, size guide,
   accordions), collection (filters, sort, load-as-you-scroll),
   recommendations and FAQ accordions. No dependencies; every piece
   is an enhancement over a page that already works without it. */
(function () {
  'use strict';

  var win = window;
  var doc = document;
  var root = doc.documentElement;
  var MOTION = function () { return root.classList.contains('nd-motion'); };
  var FINE = !!(win.matchMedia && win.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function rescan(ctx) { if (win.NDMotion && win.NDMotion.scan) win.NDMotion.scan(ctx); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------------- shared frame loop ---------------- */
  var items = [];
  var rafId = 0;
  function frame() {
    rafId = 0;
    var vh = win.innerHeight, more = false, i;
    for (i = 0; i < items.length; i++) if (items[i].read) items[i].read(vh);
    for (i = 0; i < items.length; i++) if (items[i].write && items[i].write(vh)) more = true;
    if (more) kick();
  }
  function kick() { if (!rafId) rafId = requestAnimationFrame(frame); }

  /* ---------------- 1. Cursor bubble ---------------- */
  function cursor() {
    if (!FINE || !MOTION() || doc.querySelector('.nd-cursor')) return;
    if (!doc.querySelector('[data-cursor]')) return;
    var box = doc.createElement('div');
    box.className = 'nd-cursor';
    box.setAttribute('aria-hidden', 'true');
    var label = doc.createElement('span');
    box.appendChild(label);
    doc.body.appendChild(box);

    var tx = -200, ty = -200, x = -200, y = -200, on = false, seen = false, text = '';
    function zoneAt(t) {
      var z = t && t.closest ? t.closest('[data-cursor]') : null;
      if (!z || !z.getAttribute('data-cursor')) return null;
      if (t.closest('button, input, select, textarea, .nd-swatches, video')) return null;
      return z;
    }
    function set(z) {
      if (z) {
        var t = z.getAttribute('data-cursor');
        if (t !== text) { text = t; label.textContent = t; }
      }
      var next = !!z;
      if (next !== on) { on = next; box.classList.toggle('is-on', on); }
    }
    doc.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!seen) { seen = true; x = tx; y = ty; }
      set(zoneAt(e.target));
      kick();
    }, { passive: true });
    doc.addEventListener('pointerleave', function () { set(null); });
    doc.addEventListener('scroll', function () { if (on) set(zoneAt(doc.elementFromPoint(tx, ty))); }, { capture: true, passive: true });
    items.push({
      write: function () {
        x += (tx - x) * 0.24; y += (ty - y) * 0.24;
        var moving = Math.abs(tx - x) > 0.2 || Math.abs(ty - y) > 0.2;
        if (!moving) { x = tx; y = ty; }
        box.style.setProperty('--cx', x.toFixed(1) + 'px');
        box.style.setProperty('--cy', y.toFixed(1) + 'px');
        return moving;
      }
    });
  }

  /* ---------------- 2. Colour dots preview the card image ---------------- */
  function swatches(ctx) {
    qsa('.nd-card', ctx).forEach(function (card) {
      if (card.__sw) return;
      card.__sw = 1;
      var img = card.querySelector('.nd-card__img');
      if (!img) return;
      var original = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      var dots = qsa('[data-nd-swap]', card);
      if (!dots.length) return;
      var pre = {};
      function swap(dot) {
        var url = dot.getAttribute('data-nd-swap');
        if (!url) return;
        if (!pre[url]) { pre[url] = new Image(); pre[url].src = url; }
        img.removeAttribute('srcset');
        img.setAttribute('src', url);
        dots.forEach(function (d) { d.classList.toggle('is-on', d === dot); });
      }
      function reset() {
        if (original.srcset) img.setAttribute('srcset', original.srcset);
        img.setAttribute('src', original.src);
        dots.forEach(function (d) { d.classList.remove('is-on'); });
      }
      dots.forEach(function (d) {
        d.addEventListener('mouseenter', function () { swap(d); });
        d.addEventListener('focus', function () { swap(d); });
      });
      card.addEventListener('mouseleave', reset);
    });
  }

  /* ---------------- 3. Newsletter without leaving the page ---------------- */
  function newsletter(ctx) {
    qsa('form[data-nd-newsletter]', ctx).forEach(function (form) {
      if (form.__nl) return;
      form.__nl = 1;
      if (!win.fetch || !win.FormData) return;
      form.addEventListener('submit', function (e) {
        if (form.__native) return;
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var msg = form.parentNode.querySelector('[data-nd-nl-msg]');
        if (input && !input.checkValidity()) { input.reportValidity(); return; }
        form.classList.add('is-busy');
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
          .then(function (res) {
            /* Shopify sends people to a challenge page when it wants a captcha: let the real form handle it */
            if (/\/challenge/.test(res.url)) throw new Error('challenge');
            return res.text().then(function (html) { return { url: res.url, html: html }; });
          })
          .then(function (r) {
            form.classList.remove('is-busy');
            var ok = /customer_posted=true/.test(r.url) || /posted_successfully/.test(r.html);
            if (ok) {
              var done = doc.createElement('p');
              done.className = 'nd-nl__msg nd-nl__msg--ok';
              done.setAttribute('role', 'status');
              done.textContent = form.getAttribute('data-success') || 'You’re in.';
              form.replaceWith(done);
              if (msg) msg.hidden = true;
            } else if (msg) {
              msg.hidden = false;
              msg.textContent = form.getAttribute('data-error') || 'That didn’t work. Check the email and try again.';
            }
          })
          .catch(function () {
            form.classList.remove('is-busy');
            form.__native = true;
            form.submit();
          });
      });
    });
  }

  /* ---------------- 4. Product page ---------------- */
  function product(sec) {
    if (sec.__pdp) return;
    sec.__pdp = 1;

    var dataEl = sec.querySelector('[data-pdp-variants]');
    var priceEl = sec.querySelector('[data-pdp-prices]');
    var variants = [];
    var prices = {};
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
    try { prices = priceEl ? JSON.parse(priceEl.textContent) : {}; } catch (e) {}

    var form = sec.querySelector('form[action*="/cart/add"]');
    var idInput = sec.querySelector('[data-variant-id]');
    var add = sec.querySelector('[data-add]');
    var addLabel = sec.querySelector('[data-add-label]');
    var price = sec.querySelector('[data-price]');
    var compare = sec.querySelector('[data-compare]');
    var err = sec.querySelector('[data-pdp-error]');
    var qty = sec.querySelector('[data-qty] input');
    var L = {
      add: sec.getAttribute('data-l-add') || 'Add to bag',
      added: sec.getAttribute('data-l-added') || 'Added',
      sold: sec.getAttribute('data-l-sold') || 'Sold out',
      na: sec.getAttribute('data-l-na') || 'Unavailable'
    };

    /* ----- gallery ----- */
    var gallery = sec.querySelector('[data-pdp-gallery]');
    var track = gallery ? gallery.querySelector('[data-pdp-track]') : null;
    var slides = track ? qsa('[data-media-id]', track) : [];
    var thumbs = gallery ? qsa('[data-pdp-thumb]', gallery) : [];
    var counter = gallery ? gallery.querySelector('[data-pdp-count]') : null;
    var current = 0;
    function isRow() { return track && getComputedStyle(track).display === 'flex'; }

    function setActive(i, fromScroll) {
      if (!slides.length) return;
      i = clamp(i, 0, slides.length - 1);
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      if (!fromScroll && isRow()) {
        try { track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: MOTION() ? 'smooth' : 'auto' }); }
        catch (e) { track.scrollLeft = slides[i].offsetLeft - track.offsetLeft; }
      }
    }
    slides.forEach(function (s, k) { if (s.classList.contains('is-active')) current = k; });
    if (counter && slides.length) counter.textContent = pad(current + 1) + ' / ' + pad(slides.length);
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setActive(k); }); });
    if (gallery) {
      var prev = gallery.querySelector('[data-pdp-prev]');
      var next = gallery.querySelector('[data-pdp-next]');
      if (prev) prev.addEventListener('click', function () { setActive(current - 1 < 0 ? slides.length - 1 : current - 1); });
      if (next) next.addEventListener('click', function () { setActive(current + 1 >= slides.length ? 0 : current + 1); });
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { setActive(current + 1 >= slides.length ? 0 : current + 1); }
        else if (e.key === 'ArrowLeft') { setActive(current - 1 < 0 ? slides.length - 1 : current - 1); }
      });
    }
    /* phones: the row is swiped, so the counter follows the scroll */
    if (track) {
      var st = 0;
      track.addEventListener('scroll', function () {
        if (!isRow()) return;
        clearTimeout(st);
        st = setTimeout(function () {
          var best = 0, dist = Infinity;
          slides.forEach(function (s, k) {
            var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
            if (d < dist) { dist = d; best = k; }
          });
          setActive(best, true);
        }, 60);
      }, { passive: true });
    }

    /* desktop: the photo follows the pointer when you hover it */
    if (FINE && track) {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img) return;
        s.addEventListener('pointermove', function (e) {
          if (isRow() || !s.classList.contains('is-active')) return;
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
          s.classList.add('is-peek');
        });
        s.addEventListener('pointerleave', function () { s.classList.remove('is-peek'); });
      });
    }

    /* zoom: every photo, large, opened at the one you pressed */
    var dlg = sec.querySelector('[data-pdp-zoom]');
    if (track && dlg && typeof dlg.showModal === 'function') {
      var list = dlg.querySelector('[data-zoom-list]');
      var built = false;
      track.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('img[data-zoom-src]') : null;
        if (!img) return;
        var all = qsa('img[data-zoom-src]', track);
        if (!built) {
          built = true;
          all.forEach(function (s) {
            var big = doc.createElement('img');
            big.src = s.getAttribute('data-zoom-src');
            big.alt = s.alt || '';
            big.decoding = 'async';
            big.loading = 'lazy';
            list.appendChild(big);
          });
        }
        dlg.showModal();
        root.classList.add('nd-lock');
        var at = list.children[all.indexOf(img)];
        dlg.scrollTop = at ? at.offsetTop - 10 : 0;
      });
      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-close]') || e.target === dlg || e.target.closest('[data-zoom-list]')) dlg.close();
      });
      dlg.addEventListener('close', function () { root.classList.remove('nd-lock'); });
    }

    /* ----- options ----- */
    var groups = qsa('[data-opt-index]', sec);
    var sel = {};
    groups.forEach(function (g) {
      var idx = g.getAttribute('data-opt-index');
      var on = g.querySelector('[data-val].is-active') || g.querySelector('[data-val]');
      if (on) sel[idx] = on.getAttribute('data-val');
      qsa('[data-val]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          qsa('[data-val]', g).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active');
          b.setAttribute('aria-pressed', 'true');
          sel[idx] = b.getAttribute('data-val');
          var shown = g.querySelector('[data-opt-current]');
          if (shown) shown.textContent = sel[idx];
          resolve(true);
        });
      });
    });

    function matches(v, skip) {
      for (var k = 0; k < 3; k++) {
        if (k === skip) continue;
        var s = sel[String(k)];
        if (s != null && v['option' + (k + 1)] !== s) return false;
      }
      return true;
    }

    function markAvailability() {
      groups.forEach(function (g) {
        var idx = Number(g.getAttribute('data-opt-index'));
        qsa('[data-val]', g).forEach(function (b) {
          var val = b.getAttribute('data-val');
          var any = variants.some(function (v) { return v['option' + (idx + 1)] === val && v.available && matches(v, idx); });
          b.classList.toggle('is-oos', !any);
        });
      });
    }

    function showMediaFor(v) {
      if (!v || !v.featured_media || !slides.length) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(v.featured_media.id)) { setActive(i); return; }
      }
    }

    function resolve(userChange) {
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (matches(variants[i], -1)) { v = variants[i]; break; } }
      if (!v) {
        if (add) add.disabled = true;
        if (addLabel) addLabel.textContent = L.na;
      } else {
        if (idInput) idInput.value = v.id;
        if (price && prices[v.id]) price.innerHTML = prices[v.id].p;
        if (compare) {
          var c = prices[v.id] && prices[v.id].c;
          compare.innerHTML = c || '';
          compare.hidden = !c;
        }
        if (add) add.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? L.add : L.sold;
        if (userChange) {
          showMediaFor(v);
          try {
            var url = new URL(win.location.href);
            url.searchParams.set('variant', v.id);
            win.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      }
      markAvailability();
      sec.dispatchEvent(new CustomEvent('nd:variant', { detail: v }));
    }
    resolve(false);

    /* ----- quantity ----- */
    qsa('[data-qty-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        qty.value = clamp((parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-qty-step')), 1, 99);
      });
    });
    if (qty) qty.addEventListener('change', function () { qty.value = clamp(parseInt(qty.value, 10) || 1, 1, 99); });

    /* ----- add to bag without leaving the page; the normal form post is the fallback ----- */
    var busy = false;
    function fail(m) { if (!err) return; err.textContent = m || ''; err.hidden = !m; }
    function native() {
      busy = false;
      if (add) add.classList.remove('is-busy');
      form.__native = true;
      form.submit();
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var actions = win.Shopify && win.Shopify.actions;
        if (form.__native || !actions || typeof actions.updateCart !== 'function' || !idInput || !win.Promise) return;
        e.preventDefault();
        if (busy) return;
        busy = true;
        fail('');
        if (add) add.classList.add('is-busy');
        var settled = false;
        var guard = setTimeout(function () { if (!settled) { settled = true; native(); } }, 9000);
        var call;
        try {
          call = actions.updateCart(
            { lines: [{ merchandiseId: String(idInput.value), quantity: qty ? clamp(parseInt(qty.value, 10) || 1, 1, 99) : 1 }] },
            { event: { context: 'product' } }
          );
        } catch (ex) { call = Promise.reject(ex); }
        Promise.resolve(call).then(function (res) {
          if (settled) return;
          settled = true;
          clearTimeout(guard);
          busy = false;
          if (add) add.classList.remove('is-busy');
          var errors = res && res.userErrors;
          if (errors && errors.length) { fail(errors[0].message || errors[0].description || ''); return; }
          if (addLabel) {
            var back = addLabel.textContent;
            addLabel.textContent = L.added;
            if (add) add.classList.add('is-done');
            setTimeout(function () {
              if (add) add.classList.remove('is-done');
              if (addLabel.textContent === L.added) addLabel.textContent = back;
            }, 2200);
          }
          if (typeof actions.openCart === 'function') { try { actions.openCart(); } catch (ex) {} }
        }).catch(function () {
          if (settled) return;
          settled = true;
          clearTimeout(guard);
          native();
        });
      });
    }

    /* ----- phones: a slim bar keeps the button in reach once it has scrolled away ----- */
    var bar = sec.querySelector('[data-pdp-bar]');
    if (bar && add && form) {
      var barBtn = bar.querySelector('[data-bar-add]');
      var barLabel = bar.querySelector('[data-bar-label]');
      var barPrice = bar.querySelector('[data-bar-price]');
      var sync = function () {
        if (barBtn) barBtn.disabled = add.disabled;
        if (barLabel && addLabel) barLabel.textContent = addLabel.textContent;
        if (barPrice && price) barPrice.innerHTML = price.innerHTML;
      };
      sec.addEventListener('nd:variant', sync);
      if (addLabel && 'MutationObserver' in win) new MutationObserver(sync).observe(addLabel, { childList: true, characterData: true, subtree: true });
      sync();
      var shown = false, want = false;
      items.push({
        read: function () { want = getComputedStyle(bar).display !== 'none' && add.getBoundingClientRect().bottom < 0; },
        write: function () {
          if (want === shown) return false;
          shown = want;
          bar.classList.toggle('is-on', shown);
          bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
          if (barBtn) barBtn.tabIndex = shown ? 0 : -1;
          return false;
        }
      });
      if (barBtn) barBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else add.click(); });
    }

    /* ----- size guide in a dialog ----- */
    var sg = sec.querySelector('[data-size-guide]');
    var sgOpen = sec.querySelector('[data-size-guide-open]');
    if (sg && sgOpen && typeof sg.showModal === 'function') {
      sgOpen.addEventListener('click', function (e) {
        e.preventDefault();
        sg.showModal();
        root.classList.add('nd-lock');
      });
      sg.addEventListener('click', function (e) { if (e.target === sg || e.target.closest('[data-size-guide-close]')) sg.close(); });
      sg.addEventListener('close', function () { root.classList.remove('nd-lock'); });
    }

    accordions(sec);
  }

  /* ---------------- 5. Accordions ease open and shut ---------------- */
  function accordions(ctx) {
    if (!('animate' in Element.prototype)) return;
    qsa('[data-nd-acc] details', ctx).forEach(function (d) {
      if (d.__acc) return;
      d.__acc = 1;
      var sum = d.querySelector('summary');
      var body = d.querySelector('summary ~ div');
      if (!sum || !body) return;
      var anim = null;
      sum.addEventListener('click', function (e) {
        if (!MOTION()) return;
        e.preventDefault();
        if (anim) { anim.cancel(); anim = null; }
        var closing = d.open && !d.classList.contains('is-closing');
        var from, to;
        if (closing) {
          from = body.offsetHeight;
          d.classList.add('is-closing');
          to = 0;
        } else {
          d.classList.remove('is-closing');
          d.open = true;
          to = body.offsetHeight;
          from = 0;
        }
        anim = body.animate(
          [{ height: from + 'px', opacity: closing ? 1 : 0 }, { height: to + 'px', opacity: closing ? 0 : 1 }],
          { duration: closing ? 320 : 480, easing: 'cubic-bezier(.16,1,.3,1)' }
        );
        anim.onfinish = function () {
          anim = null;
          if (closing) { d.open = false; d.classList.remove('is-closing'); }
        };
      });
    });
  }

  /* ---------------- 6. Collection ---------------- */
  function collection(sec) {
    if (sec.__coll) return;
    sec.__coll = 1;

    /* filters and sort submit as soon as they change */
    qsa('form[data-nd-filters]', sec).forEach(function (f) {
      f.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'number') return;
        if (f.requestSubmit) f.requestSubmit(); else f.submit();
      });
    });

    /* filter sheet on phones */
    var sheet = sec.querySelector('[data-nd-sheet]');
    var openers = qsa('[data-nd-sheet-open]', sec);
    if (sheet && typeof sheet.showModal === 'function') {
      openers.forEach(function (b) {
        b.addEventListener('click', function () { sheet.showModal(); root.classList.add('nd-lock'); });
      });
      sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('[data-nd-sheet-close]')) sheet.close(); });
      sheet.addEventListener('close', function () { root.classList.remove('nd-lock'); });
    }

    /* more products arrive as you reach the end of the grid */
    var grid = sec.querySelector('[data-nd-grid]');
    var more = sec.querySelector('[data-nd-more]');
    if (!grid || !more || !win.fetch || !win.DOMParser) return;
    var loading = false;
    function load() {
      var url = more.getAttribute('data-next');
      if (loading || !url) return;
      loading = true;
      more.classList.add('is-busy');
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = page.querySelector('[data-nd-grid]');
          var newMore = page.querySelector('[data-nd-more]');
          if (newGrid) {
            var start = grid.children.length;
            Array.prototype.slice.call(newGrid.children).forEach(function (li, i) {
              li.style.setProperty('--i', i % 8);
              grid.appendChild(doc.importNode(li, true));
            });
            var added = Array.prototype.slice.call(grid.children, start);
            added.forEach(function (li) { li.setAttribute('data-nd', 'rise'); });
            rescan(grid);
            swatches(grid);
          }
          var nextUrl = newMore ? newMore.getAttribute('data-next') : '';
          if (nextUrl) {
            more.setAttribute('data-next', nextUrl);
            var a = more.querySelector('a');
            if (a) a.setAttribute('href', nextUrl);
          } else {
            more.remove();
            more = null;
          }
          var shown = sec.querySelector('[data-nd-shown]');
          if (shown) shown.textContent = grid.children.length;
        })
        .catch(function () { /* the link still works */ })
        .then(function () { loading = false; if (more) more.classList.remove('is-busy'); });
    }
    var a = more.querySelector('a');
    if (a) a.addEventListener('click', function (e) { e.preventDefault(); load(); });
    if ('IntersectionObserver' in win) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && more) load(); });
        if (!more) io.disconnect();
      }, { rootMargin: '0px 0px 700px 0px' });
      io.observe(more);
    }
  }

  /* ---------------- 7. Recommendations ---------------- */
  function recommendations(ctx) {
    qsa('[data-nd-recs]', ctx).forEach(function (el) {
      if (el.__recs || !win.fetch) return;
      el.__recs = 1;
      var url = el.getAttribute('data-url');
      if (!url) return;
      var go = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-nd-recs]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            el.hidden = false;
            rescan(el);
            swatches(el);
          }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in win) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); go(); }
        }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(el.parentNode || el);
      } else go();
    });
  }

  /* ---------------- 8. FAQ pages: questions become accordions ---------------- */
  function faq(ctx) {
    qsa('[data-nd-faq]', ctx).forEach(function (box) {
      if (box.__faq) return;
      box.__faq = 1;
      var heads = qsa('h3', box);
      if (!heads.length) return;
      var wrap = doc.createElement('div');
      wrap.className = 'nd-faq';
      wrap.setAttribute('data-nd-acc', '');
      heads[0].parentNode.insertBefore(wrap, heads[0]);
      heads.forEach(function (h) {
        var d = doc.createElement('details');
        var s = doc.createElement('summary');
        s.innerHTML = h.innerHTML + '<i aria-hidden="true"></i>';
        var body = doc.createElement('div');
        var n = h.nextElementSibling;
        while (n && n.tagName !== 'H3') {
          var nx = n.nextElementSibling;
          body.appendChild(n);
          n = nx;
        }
        d.appendChild(s);
        d.appendChild(body);
        h.remove();
        wrap.appendChild(d);
      });
      accordions(box);
    });
  }

  /* ---------------- Start ---------------- */
  function setup(ctx) {
    swatches(ctx);
    newsletter(ctx);
    qsa('[data-nd-pdp]', ctx).forEach(product);
    qsa('[data-nd-coll]', ctx).forEach(collection);
    recommendations(ctx);
    faq(ctx);
    accordions(ctx);
    cursor();
    kick();
  }

  function start() { try { setup(doc); } catch (e) { if (win.console) console.warn('[nd]', e); } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();

  doc.addEventListener('scroll', kick, { capture: true, passive: true });
  win.addEventListener('resize', kick);
  doc.addEventListener('shopify:section:load', function (e) { try { setup(e.target); } catch (err) {} });
})();
